const QUERYTYPES = {
  ITEM: "ITEM",
  CCO: "CCO",
  PENDINGISSUE: "PENDINGISSUE",
  RFI: "RFI",
  LABOR: "LABOR",
  EQUIPMENT: "EQUIPMENT",
  CONTRACTOR: "CONTRACTOR",
};

export default QUERYTYPES;
